import store from "@/store";
import experimentMixin from "@/mixins/experiment-mixin.js";
import { experimentSettings } from "@/constants/experiments";
import { navigationScenarios } from "@/router/constants/navigation-scenarios";
import { routeData } from "@/router/constants/routes";

export function shouldSkipCoverageStatement() {
    return (
        store.getters.order?.isNewInsuranceFlow &&
        store.getters.order?.payment?.isClaimAndCoverage &&
        experimentMixin.methods.hasSettingEqualTo(
            experimentSettings.SHOW_UNVERIFIED_DEDUCT_ENTRY,
            "true"
        )
    );
}

export function coverageStatementBeforeEnter(to, from) {
    const cameFromSchedule =
        from?.name === routeData.SCHEDULE.name || from?.name === routeData.SCHEDULING.name;

    if (cameFromSchedule) {
        return;
    }

    if (!shouldSkipCoverageStatement()) {
        return;
    }

    return {
        name: routeData.SCHEDULE.name,
    };
}

export function getScheduleClaimAndCoverageBackScenario() {
    if (!store.getters.order?.isNewInsuranceFlow) {
        return null;
    }

    if (!shouldSkipCoverageStatement()) {
        return navigationScenarios.CLICKED_BACK_TO_COVERAGE_STATEMENT;
    }

    if (store.getters.isRecalibrationOnOrder) {
        return navigationScenarios.CLICKED_BACK_TO_RECALIBRATION_INFO;
    }

    return navigationScenarios.CLICKED_BACK_TO_POLICY_INFO_SUBMITTED;
}
